// let style = document.createElement('style');
// style.type = 'text/css';

// style.textContext = '@import url("https://editor.aws.key2print.com/fonts/c992d063-9ff7-11ea-87fb-0286caf1a0b6/LinkedIn%20Community/Regular/Community-Semibold.otf);'

// document.getElementsByTagName('head')[0].appendChild(style);

export const addFont = (fontFamily, fontUrl, fontWeight, fontStyle) =>  {
    const style = document.createElement('style');
    const fontFormat = fontUrl.split('.')[fontUrl.split('.').length - 1];

    let useFormat = 'opentype';

    switch (fontFormat) {
      case 'otf':
        useFormat = 'opentype';
        break;
      case 'ttf':
        useFormat = 'truetype';
        break;
    }

    style.textContent = `@font-face {
      font-family: ${fontFamily};
      src: url("${fontUrl}") format('${useFormat}');
      font-weight: ${fontWeight};
      font-style: ${fontStyle};
    }`;
    // document.head.append(style);

    return style;
}